export function initConfigurateOrderStep3() : void {
    document.querySelectorAll<HTMLElement>('.js-configurate-order-step-3').forEach($dcvModule => {
        new ConfigurateOrderStep3($dcvModule);
    });
}

class ConfigurateOrderStep3 {
    $container: HTMLElement;
    $dcvSelectFields: NodeListOf<HTMLSelectElement>;
    $dcvDiffersSubdomainCheckbox: NodeListOf<HTMLInputElement>;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$dcvSelectFields = this.$container.querySelectorAll<HTMLSelectElement>('select.dcv_method');
        this.$dcvDiffersSubdomainCheckbox = this.$container.querySelectorAll<HTMLInputElement>('.js-dcv-differs-subdomain-checkbox');

        this.$dcvDiffersSubdomainCheckbox.forEach($dcvDiffersSubdomainCheckbox => {
            this.dcvDiffersSubdomainCheckboxOpenExpand($dcvDiffersSubdomainCheckbox);
            $dcvDiffersSubdomainCheckbox.addEventListener('change', () => this.dcvDiffersSubdomainCheckboxOpenExpand($dcvDiffersSubdomainCheckbox));
        });

        // Show validation method details on select
        this.$dcvSelectFields.forEach($select => {
            const togglerClass = $select.dataset.togglerClass;
            const $elements = document.querySelectorAll(`[class*="${togglerClass}"]`);

            $select.addEventListener('change', () => {
                $elements.forEach($element => {
                    if ($element.classList.contains(`${togglerClass}-${$select.value.toLowerCase()}`)) {
                        $element.classList.remove('hidden');
                    } else {
                        $element.classList.add('hidden');
                    }
                });
            });
        });
    }

    /**
     * Open expand with checkbox
     * 
     * @param {HTMLInputElement} $checkbox
     * 
     * @return {void}
     */
    dcvDiffersSubdomainCheckboxOpenExpand($checkbox: HTMLInputElement) : void {
        const $expand = $checkbox.closest<HTMLElement>('.configurate-order-main-domain')?.querySelector<HTMLElement>('.js-expand-collapse');

        if ($expand) {
            $expand.classList.toggle('open', $checkbox.checked);
        }
    }
}
